module.exports = __webpack_public_path__ + "img/edge-radius.49631568.png";